/* ============================================================
   VS CART DRAWER — Vita Santé (vs-cart-drawer.js)
   S'appuie sur le JS natif du thème Paris (cart-drawer.js) :
   - Redéfinit window.shippingProgressBar, appelée par le thème
     après chaque ouverture / mise à jour du panier, pour piloter
     la barre de récompenses à paliers.
   - Gère : sélection de couleur + ajout du produit récompense,
     ajout des upsells, code promo.
   Chargé en defer APRÈS les scripts du thème (donc notre
   définition de shippingProgressBar remplace la native).
   ============================================================ */

(function () {
  'use strict';

  var cfg = window.VSDrawerConfig || {};
  var selectedVariantId = null;

  /* ---------- Utilitaires ---------- */

  function formatMoney(cents) {
    // Format simple québécois : "12,99 $". Le format exact vient de
    // Shopify si disponible.
    var value = (cents / 100).toFixed(2).replace('.', ',');
    var fmt = cfg.moneyFormat || '{{amount_with_comma_separator}} $';
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value)
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  /* ---------- Rafraîchir le drawer (même mécanique que le thème) ---------- */

  function refreshDrawer() {
    return fetch('?section_id=mini-cart')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-drawer');
        var current = document.getElementById('minicart');
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          // Ré-attacher les boutons de fermeture (comme openDrawer natif)
          current.querySelectorAll('[data-sideDrawer-close]').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
              e.preventDefault();
              current.classList.remove('active');
              document.body.classList.remove('no-scroll');
            });
          });
          // Mettre à jour la pastille du header
          var count = doc.querySelector('mini-cart');
          var bubble = qs('[data-header-cart-count]');
          if (count && bubble) {
            var n = parseInt(count.getAttribute('data-cart-count'), 10) || 0;
            bubble.classList.toggle('hidden', n === 0);
            bubble.textContent = n < 100 ? n : '';
          }
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateRewardsBar(cart);
      })
      .catch(function (e) { console.error('[VS Drawer] refresh:', e); });
  }

  /* ---------- Barre de récompenses à paliers ---------- */

  function updateRewardsBar(cart) {
    var wrap = qs('[data-vs-rewards]');
    if (!wrap) return;

    var seuil1 = parseInt(wrap.dataset.seuil1, 10) || cfg.seuil1 || 12500;
    var seuil2 = parseInt(wrap.dataset.seuil2, 10) || cfg.seuil2 || 15000;

    // Total AVANT rabais : c'est ce montant qui détermine les paliers,
    // comme l'évaluation du montant minimum des rabais automatiques.
    var raw = cart && typeof cart.original_total_price === 'number'
      ? cart.original_total_price
      : (cart && cart.total_price) || 0;

    var pct = Math.min(100, Math.round((raw / seuil2) * 100));
    var bar = qs('[data-vs-bar]', wrap);
    if (bar) bar.style.width = pct + '%';

    var ck1 = qs('[data-vs-ck1]', wrap);
    var ck2 = qs('[data-vs-ck2]', wrap);
    if (ck1) ck1.classList.toggle('is-on', raw >= seuil1);
    if (ck2) ck2.classList.toggle('is-on', raw >= seuil2);

    // Message dynamique
    var msgEl = qs('[data-vs-msg]', wrap);
    if (msgEl && cfg.msg) {
      var rewardInCart = countRewardInCart(cart);
      var txt;
      if (raw >= seuil2) {
        txt = cfg.msg.all;
      } else if (raw >= seuil1) {
        var m2 = formatMoney(seuil2 - raw);
        txt = (rewardInCart > 0 ? cfg.msg.afterT1Recup : cfg.msg.afterT1)
          .replace('[montant]', m2);
      } else {
        txt = cfg.msg.beforeT1.replace('||price||', formatMoney(seuil1 - raw));
      }
      msgEl.textContent = txt;
    }

    updateRewardCard(cart, raw, seuil2);
    loadSmartUpsells(cart);
  }

  /* ---------- Upsells intelligents : produits COMPLÉMENTAIRES au panier ----------
     S'appuie sur l'app gratuite Shopify Search & Discovery : les
     « produits complémentaires » définis par produit dans l'admin sont
     exposés via /recommendations/products.json (intent=complementary).
     S'il n'y a pas de recommandations configurées, le rendu Liquid
     (collection ou liste manuelle) reste affiché tel quel. ---------- */

  function loadSmartUpsells(cart) {
    if (!cfg.upsellSmart) return;
    var wrap = qs('[data-vs-upsells]');
    if (!wrap || !cart || !cart.items || !cart.items.length) return;

    var cartPids = cart.items.map(function (i) { return i.product_id; });

    // Interroger les complémentaires des 3 premiers articles du panier
    var queries = cartPids.slice(0, 3).map(function (pid) {
      return fetch('/recommendations/products.json?product_id=' + pid + '&limit=6&intent=complementary')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .catch(function () { return { products: [] }; });
    });

    Promise.all(queries).then(function (results) {
      var seen = {};
      var recos = [];
      results.forEach(function (r) {
        (r.products || []).forEach(function (p) {
          if (!seen[p.id] && cartPids.indexOf(p.id) === -1 && p.available !== false) {
            seen[p.id] = true;
            recos.push(p);
          }
        });
      });
      if (!recos.length) return; // repli : rendu Liquid inchangé

      wrap.innerHTML = recos.slice(0, cfg.upsellCount || 3).map(function (p) {
        var variants = (p.variants || []).filter(function (v) { return v.available !== false; });
        var firstId = variants.length ? variants[0].id : null;
        if (!firstId) return '';
        var imgUrl = p.featured_image || '';
        if (imgUrl) {
          imgUrl += (imgUrl.indexOf('?') === -1 ? '?' : '&') + 'width=120';
        }
        var img = imgUrl ? '<img src="' + imgUrl + '" alt="" width="60" height="60" loading="lazy">' : '';
        var selectHtml = '';
        if (variants.length > 1) {
          selectHtml = '<select class="vs-upsell__variant" data-vs-upsell-variant aria-label="Choisir la variante">' +
            variants.map(function (v) {
              return '<option value="' + v.id + '">' + escapeHtml(v.title) + '</option>';
            }).join('') + '</select>';
        }
        return '<div class="vs-upsell">' +
          '<a href="' + p.url + '" class="vs-upsell__img">' + img + '</a>' +
          '<div class="vs-upsell__info">' +
            '<a href="' + p.url + '" class="vs-upsell__name">' + escapeHtml(p.title) + '</a>' +
            '<div class="vs-upsell__price"><span>' + formatMoney(p.price) + '</span></div>' +
          '</div>' +
          selectHtml +
          '<button type="button" class="vs-upsell__add" data-vs-add="' + firstId + '">' + escapeHtml(cfg.upsellBtnText || 'Ajouter') + '</button>' +
        '</div>';
      }).join('');
    });
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function countRewardInCart(cart) {
    if (!cart || !cart.items || !cfg.rewardProductId) return 0;
    return cart.items.reduce(function (sum, item) {
      return item.product_id === cfg.rewardProductId ? sum + item.quantity : sum;
    }, 0);
  }

  function updateRewardCard(cart, raw, seuil2) {
    var card = qs('[data-vs-reward-card]');
    if (!card || !cfg.rewardEnabled) return;
    var tranches = cfg.recurrent ? Math.floor(raw / seuil2) : (raw >= seuil2 ? 1 : 0);
    var inCart = countRewardInCart(cart);
    card.hidden = !(tranches > inCart);
  }

  // ★ Point d'ancrage : le thème Paris appelle cette fonction après
  // chaque ouverture du drawer et chaque mise à jour AJAX du panier.
  // Blindée : ne doit JAMAIS lancer d'erreur qui couperait le flux natif.
  window.shippingProgressBar = function () {
    try {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          try { updateRewardsBar(cart); } catch (e) { console.error('[VS Drawer] bar:', e); }
        })
        .catch(function (e) { console.error('[VS Drawer] bar:', e); });
    } catch (e) {
      console.error('[VS Drawer] bar:', e);
    }
  };

  /* ---------- Interactions (délégation : survit aux re-rendus AJAX) ---------- */

  document.addEventListener('click', function (e) {

    // --- Pastille de couleur du produit récompense ---
    var swatch = e.target.closest('[data-vs-swatch]');
    if (swatch) {
      e.preventDefault();
      selectedVariantId = swatch.dataset.vsSwatch;
      document.querySelectorAll('[data-vs-swatch]').forEach(function (s) {
        s.classList.toggle('is-selected', s === swatch);
      });
      var addBtn = qs('[data-vs-reward-add]');
      if (addBtn) addBtn.disabled = false;
      return;
    }

    // --- Ajouter le produit récompense ---
    var rewardAdd = e.target.closest('[data-vs-reward-add]');
    if (rewardAdd) {
      e.preventDefault();
      if (!selectedVariantId) return;
      addToCart(selectedVariantId, rewardAdd).then(function () {
        selectedVariantId = null;
      });
      return;
    }

    // --- Retirer le code promo appliqué ---
    var promoRemove = e.target.closest('[data-vs-promo-remove]');
    if (promoRemove) {
      e.preventDefault();
      // Le code promo vit dans un témoin (cookie) première partie : on l'expire.
      document.cookie = 'discount_code=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      refreshDrawer();
      return;
    }

    // --- Ajouter un upsell (avec variante choisie si présente) ---
    var upsellAdd = e.target.closest('[data-vs-add]');
    if (upsellAdd) {
      e.preventDefault();
      var card = upsellAdd.closest('.vs-upsell');
      var variantSelect = card ? card.querySelector('[data-vs-upsell-variant]') : null;
      var variantId = variantSelect ? variantSelect.value : upsellAdd.dataset.vsAdd;
      addToCart(variantId, upsellAdd);
      return;
    }

    // --- Vider le panier (confirmation en 2 taps) ---
    var clearBtn = e.target.closest('[data-vs-clear-cart]');
    if (clearBtn) {
      e.preventDefault();
      var lbl = clearBtn.querySelector('[data-vs-clear-label]');
      if (!clearBtn.classList.contains('is-confirm')) {
        clearBtn.classList.add('is-confirm');
        if (lbl) { lbl.dataset.orig = lbl.textContent; lbl.textContent = 'Confirmer ?'; }
        setTimeout(function () {
          clearBtn.classList.remove('is-confirm');
          if (lbl && lbl.dataset.orig) lbl.textContent = lbl.dataset.orig;
        }, 3000);
      } else {
        clearBtn.classList.remove('is-confirm');
        fetch('/cart/clear.js', { method: 'POST' })
          .then(function () { return refreshDrawer(); })
          .catch(function (err) { console.error('[VS Drawer] clear:', err); });
      }
      return;
    }

    // --- Déplier / replier le code promo (mobile) ---
    var promoToggle = e.target.closest('[data-vs-promo-toggle]');
    if (promoToggle) {
      e.preventDefault();
      var promoBox = qs('[data-vs-promo]');
      if (promoBox) {
        promoBox.classList.toggle('is-open');
        if (promoBox.classList.contains('is-open')) {
          var inp = qs('[data-vs-promo-input]', promoBox);
          if (inp) inp.focus();
        }
      }
      return;
    }

    // --- Appliquer un code promo ---
    var promoBtn = e.target.closest('[data-vs-promo-apply]');
    if (promoBtn) {
      e.preventDefault();
      applyPromo();
    }
  });

  // Entrée clavier dans le champ promo
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-vs-promo-input]')) {
      e.preventDefault();
      applyPromo();
    }
  });

  function addToCart(variantId, btn) {
    if (btn) btn.classList.add('is-loading');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add ' + r.status);
        return refreshDrawer();
      })
      .catch(function (e) {
        console.error('[VS Drawer] add:', e);
        var errBox = qs('#CartDrawer-CartErrors');
        if (errBox) errBox.textContent = 'Oups, impossible d\u2019ajouter le produit. R\u00e9essaie.';
      })
      .finally(function () {
        if (btn) btn.classList.remove('is-loading');
      });
  }

  /* ---------- Code promo ---------- */

  function applyPromo() {
    var input = qs('[data-vs-promo-input]');
    var msg = qs('[data-vs-promo-msg]');
    if (!input || !input.value.trim()) return;
    var code = input.value.trim();

    // Le endpoint /discount/CODE dépose le cookie de rabais ;
    // Shopify l'applique au panier et au checkout.
    fetch('/discount/' + encodeURIComponent(code))
      .then(function () { return refreshDrawer(); })
      .then(function () {
        if (msg) {
          msg.hidden = false;
          msg.classList.remove('is-error');
          msg.textContent = 'Code \u00ab ' + code + ' \u00bb appliqu\u00e9 \u2014 le rabais s\u2019affichera au paiement s\u2019il est valide.';
        }
      })
      .catch(function () {
        if (msg) {
          msg.hidden = false;
          msg.classList.add('is-error');
          msg.textContent = 'Impossible d\u2019appliquer ce code pour le moment.';
        }
      });
  }

  /* ---------- Masquer la bulle de chat (Shopify Inbox) quand le drawer est ouvert ---------- */

  var hiddenChatEls = [];

  function setChatHidden(hide) {
    if (hide) {
      var candidates = [];

      // 1) Sélecteurs connus de Shopify Inbox (id, classe ET balise personnalisée)
      ['shopify-chat', '#shopify-chat', '#ShopifyChat', '.shopify-chat', '#chat-button', '[id^="dummy-chat"]']
        .forEach(function (sel) {
          try {
            document.querySelectorAll(sel).forEach(function (el) {
              if (candidates.indexOf(el) === -1) candidates.push(el);
            });
          } catch (err) { /* sélecteur non supporté : ignorer */ }
        });

      // 2) Heuristique : tout enfant direct de <body> flottant (fixed),
      //    petit, et ancré près du bas de l'écran = bulle de widget
      Array.prototype.slice.call(document.body.children).forEach(function (el) {
        if (el.id === 'minicart' || el.querySelector && el.querySelector('#minicart')) return;
        if (candidates.indexOf(el) !== -1) return;
        var isChatLike = el.shadowRoot || /chat|inbox/i.test(el.tagName + ' ' + el.id + ' ' + (el.className || ''));
        var cs = window.getComputedStyle(el);
        if (cs.position === 'fixed') {
          var r = el.getBoundingClientRect();
          var smallBubble = r.width > 0 && r.width < 340 && r.height < 220 && r.bottom > window.innerHeight - 240;
          if (smallBubble || isChatLike) candidates.push(el);
        } else if (isChatLike) {
          candidates.push(el);
        }
      });

      candidates.forEach(function (el) {
        if (hiddenChatEls.indexOf(el) === -1) {
          el.dataset.vsPrevDisplay = el.style.display || '';
          el.style.setProperty('display', 'none', 'important');
          hiddenChatEls.push(el);
        }
      });
    } else {
      hiddenChatEls.forEach(function (el) {
        el.style.removeProperty('display');
        if (el.dataset.vsPrevDisplay) el.style.display = el.dataset.vsPrevDisplay;
        delete el.dataset.vsPrevDisplay;
      });
      hiddenChatEls = [];
    }
  }

  // Le thème ajoute/retire la classe "no-scroll" sur <body> à l'ouverture
  // et la fermeture du drawer : on s'y synchronise. Petit délai à
  // l'ouverture pour attraper les widgets injectés tardivement.
  var chatSyncTimer = null;
  new MutationObserver(function () {
    var open = document.body.classList.contains('no-scroll');
    setChatHidden(open);
    clearTimeout(chatSyncTimer);
    if (open) {
      chatSyncTimer = setTimeout(function () { setChatHidden(true); }, 600);
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  /* ---------- Premier rendu ---------- */

  document.addEventListener('DOMContentLoaded', function () {
    // État initial correct même avant la première ouverture du drawer
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(updateRewardsBar)
      .catch(function () {});
  });
})();
